import React from 'react';
import PropTypes from 'prop-types';

import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import OEIcon from '../../elements/oe-icon';
import OEIconCodes from '../../../lib/oe-icon-codes';
import {OETransitionGroup} from '../../../lib/components/oe-transitions';

export default class OEInfoViewItemView extends React.PureComponent {

    constructor(props) {
        super(props);
        
        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.onToggle = this.onToggle.bind(this);
        this.onAnimFinished = this.onAnimFinished.bind(this);
    }

    onConnect()  {
    }

    onRelease()    {
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            return;
        }
    }
    
    renderHeader()  {
        if(!this.props.isMaximizeable)  return null;

        const toggle = this.props.notMinimizeable ? null : (
            <div className={'rot-toggle info-view-item-toggle' + (this.props.isMaximized ? ' rot-rotate-toggle' : '')}>
                <OEIcon code={OEIconCodes.caretRight}/>
            </div>
        );

        return ( 
            <div className='info-view-item-header' onClick={this.onToggle}>
                {toggle}
                <div className='info-view-item-title-label'>
                    <span>{this.props.title}</span>
                </div>
            </div>
        );
    }

    render() {
        const content = !this.props.isMaximizeable || this.props.isMaximized || this.props.notMinimizeable ? (
            <div className="info-view-item-content">
                {this.props.children}
            </div>
        ) : null;

        const separator = this.props.hasSeparator === true ? <div className="info-view-item-separator std-label-text-color-bg"/> : null;

        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                <div className={this.props.className + " info-view-item"} ref={this.props.elementRef}>
                    {separator}
                    {this.renderHeader()}
                    <OETransitionGroup duration={666} onAnimFinished={this.onAnimFinished}>
                        {content}
                    </OETransitionGroup>
                </div>
            </React.Fragment>
        );
    }

    onToggle()  {
        if(typeof(this.props.onToggle) === 'function')  {
            this.props.onToggle();
        }
    }

    onAnimFinished()   {
        if(typeof(this.props.onAnimFinished) === 'function')    {
            this.props.onAnimFinished();
        }
    }
}

OEInfoViewItemView.defaultProps = {
    className: '',
    moduleId: '',
    elementRef: '',
    isMaximizeable: true,
    isMaximized: false,
    notMinimizeable: false,
    hasSeparator: true,
    title: ''
};

OEInfoViewItemView.propTypes = {
    className: PropTypes.string,
    moduleId: PropTypes.string,
    isMaximizeable: PropTypes.bool,
    isMaximized: PropTypes.bool,
    notMinimizeable: PropTypes.bool,
    hasSeparator: PropTypes.bool,
    title: PropTypes.string
};